import React from "react";
import styled from "styled-components";
import { Spinner } from "components/common";
import { Button } from "components/bootstrap";
import { Row } from "common/components";
import { useExecuteEventProcedureActionBulk } from "security-app/hooks/useEventProceduresAPI";
import { ActionButtonStyled } from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/ActionButtonStyled";
import { IMPLEMENTED_STEP_ACTION_TYPES } from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/ProcedureStepEvents";
const BulkActionUnavailable = styled(Button)`
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-shrink: 0;
  background-color: transparent;
  border: none;
  cursor: default;

  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
export const isImplementedAction = (step) => {
  var _a, _b, _c, _d;
  return step.action && Object.keys(IMPLEMENTED_STEP_ACTION_TYPES).includes((_b = (_a = step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type) && !((_d = (_c = step.action) == null ? void 0 : _c.config) == null ? void 0 : _d.use_saved_search);
};
export function BulkStepActionButton({ step, eventIds, labelFor }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { executeEventProcedureActionBulk, executingEventProcedureActionBulk } = useExecuteEventProcedureActionBulk();
  const onActionClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    executeEventProcedureActionBulk({ eventIds, stepId: step.id }).then(
      (actionResp) => {
        if (actionResp.redirect_uri) window.open(actionResp.redirect_uri, "_blank", "noopener noreferrer");
      }
    );
  };
  if (!(step == null ? void 0 : step.action)) return void 0;
  return isImplementedAction(step) ? /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm", $width: "auto" }, /* @__PURE__ */ React.createElement(
    ActionButtonStyled,
    {
      title: (_c = IMPLEMENTED_STEP_ACTION_TYPES[(_b = (_a = step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type]) == null ? void 0 : _c[labelFor],
      bsStyle: "gray",
      bsSize: "xs",
      "aria-label": (_f = IMPLEMENTED_STEP_ACTION_TYPES[(_e = (_d = step.action) == null ? void 0 : _d.config) == null ? void 0 : _e.type]) == null ? void 0 : _f[labelFor],
      style: { borderRadius: "4px" },
      onClick: onActionClick
    },
    executingEventProcedureActionBulk && /* @__PURE__ */ React.createElement(Spinner, { text: "" }),
    executingEventProcedureActionBulk || ((_i = IMPLEMENTED_STEP_ACTION_TYPES[(_h = (_g = step.action) == null ? void 0 : _g.config) == null ? void 0 : _h.type]) == null ? void 0 : _i[labelFor])
  )) : /* @__PURE__ */ React.createElement(BulkActionUnavailable, null, "Bulk Action not Available");
}
export default (event) => {
  const { step, event_ids } = event;
  if (!(step == null ? void 0 : step.action)) return void 0;
  return /* @__PURE__ */ React.createElement(BulkStepActionButton, { step, eventIds: event_ids, labelFor: "groupLabel" });
};
